import { Button, MuiAlert, ResponsiveDrawer, strIsNullOrEmpty } from '@fox/atoms';
import { useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useContentContext } from '../../../content-context';
export function InvoicePdfButton({ invoiceId }: { invoiceId: number }) {
	const { contentId, requestToken } = useContentContext();
	const [loading, setLoading] = useState<boolean>(false);
	const [pdf, setPdf] = useState<string | null>(null);
	const [error, setError] = useState<string>('');

	const isMobile = useMediaQuery('(max-width: 800px)');

	if (error) return <MuiAlert severity="error">{error}</MuiAlert>;

	return (
		<>
			<Button
				variant="primary"
				sx={{ alignSelf: 'start' }}
				disabled={loading}
				onClick={async () => {
					setLoading(true);
					setError('');
					let url = `/Umbraco/Api/Membership/InvoicePdf?contentId=${contentId}&invoiceId=${invoiceId}`;
					const res = await fetch(url, {
						method: 'GET',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
							RequestVerificationToken: requestToken
						}
					});
					if (res.ok) {
						var result = await res.json();
						if (result.success === true) {
							setPdf(result.result);
						} else {
							setError(result.message);
						}
					} else {
						const error = await res.text();
						setError(error);
					}
					setLoading(false);
				}}
			>
				PDF
			</Button>
			{isMobile ? (
				<ResponsiveDrawer
					headerVariant="h5"
					placement="bottom"
					title="Export to PDF"
					width="100%"
					height="100%"
					style={{ height: '100%' }}
					open={!strIsNullOrEmpty(pdf)}
					onClose={() => setPdf(null)}
				>
					{pdf ? <iframe title="Export to PDF" width="100%" height="100%" src={pdf}></iframe> : <></>}
				</ResponsiveDrawer>
			) : (
				<ResponsiveDrawer
					headerVariant="h5"
					open={!strIsNullOrEmpty(pdf)}
					width={800}
					title="Export to PDF"
					onClose={() => setPdf(null)}
				>
					<>{pdf ? <iframe title="Export to PDF" width="100%" height="100%" src={pdf}></iframe> : <></>}</>
				</ResponsiveDrawer>
			)}
		</>
	);
}
